import React,{useContext} from 'react';

import { ThemeContext } from '../../contexts/ThemeContext';

import { servicesData } from '../../data/servicesData';

import './Services.css'
import SingleService from './SingleService/SingleService';

function Services() {

    const { theme } = useContext(ThemeContext);
    return (
        <>
            {servicesData.length > 0 && (
                <div className="services" id="services" style={{backgroundColor:theme.secondary}}>
                    <div className="services-shell">
                        <div className="services-header">
                            <p className='section-kicker'>Services</p>
                            <h1 style={{color: theme.primary}}>What I can build for your team</h1>
                            <p style={{color:theme.tertiary80}}>
                                Design and deliver modern web platforms, cloud-native APIs, and polished product experiences.
                            </p>
                        </div>
                        <div className="services-body">
                            <div className="services-bodycontainer">
                                {servicesData.map(services => (
                                    <SingleService
                                        key={services.id}
                                        id={services.id}
                                        title={services.title}
                                        icon={services.icon}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}
       </>
    )
}

export default Services
